/* RESOURCES */
export const ADD_REFERRAL = "ADD_REFERRAL"
export const ADD_REFERRAL_SUCCESS = "ADD_REFERRAL_SUCCESS"
export const ADD_REFERRAL_FAIL = "ADD_REFERRAL_FAIL"
export const GET_REFERRAL = "GET_REFERRAL"
export const GET_REFERRAL_SUCCESS = "GET_REFERRAL_SUCCESS"
export const GET_REFERRAL_FAIL = "GET_REFERRAL_FAIL"
export const UPDATE_REFERRAL = "UPDATE_REFERRAL"
export const UPDATE_REFERRAL_SUCCESS = "UPDATE_REFERRAL_SUCCESS"
export const UPDATE_REFERRAL_FAIL = "UPDATE_REFERRAL_FAIL"

